/**
 * Function to handle Laravel endpoint selection
 * Manages endpoint selection via URL parameter or cookie
 */
(() => {
	/**
	 * Set, or clear, the Laravel endpoint cookie
	 */
	const setCookieEndpoint = (endpoint?: string) => {
		if (endpoint) {
			document.cookie = `laravel_endpoint=${endpoint}; Secure; SameSite=Strict; path=/`;
		} else {
			document.cookie = `laravel_endpoint=; Max-Age=-99999999; Secure; SameSite=Strict; path=/`;
		}
	};

	// Wait for the DOM to be fully loaded before executing
	document.addEventListener('DOMContentLoaded', () => {
		// Find all Laravel endpoint picker forms in the document
		const forms = document.querySelectorAll<HTMLFormElement>(".laravel-endpoint-picker");
		for (const form of forms) {
			const dropdown = form.querySelector("select");
			if (!dropdown) {
				continue;
			}

			// 1) Determine the active endpoint
			let activeEndpoint: string | undefined;
			const potentialLaravelEndpointParameter = new URLSearchParams(location.search).get("laravel_endpoint");
			if (potentialLaravelEndpointParameter) {
				// An endpoint is specified in the URL query parameters
				activeEndpoint = potentialLaravelEndpointParameter;
				// Add https:// prefix if the endpoint doesn't have it and isn't in the dropdown options
				if (![...dropdown.options].some(opt => opt.value === activeEndpoint) && !activeEndpoint.startsWith("http")) {
					activeEndpoint = `https://${activeEndpoint}`;
				}

				// Store the endpoint
				setCookieEndpoint(activeEndpoint);

				// Redirect to cleaned URL. Remove the parameter from URL to avoid reapplying on page reload
				const loc = new URL(location.href);
				loc.searchParams.delete("laravel_endpoint");
				window.location.href = loc.toString();

				return;
			} else {
				// If no URL parameter, check for endpoint in cookies
				activeEndpoint = `; ${document.cookie}`.split(`; laravel_endpoint=`)[1]?.split(';').shift();
				if (!activeEndpoint && dropdown.value) {
					setCookieEndpoint(activeEndpoint = dropdown.value);
				}
			}
			
			// 2) Select the active endpoint in the dropdown
			let activeEndpointIsValid = false;
			for (const option of dropdown.options) {
				if (option.value === activeEndpoint) {
					activeEndpointIsValid = true;
					if (!option.selected) {
						option.label += " (active)";
						option.selected = true;
					}
				} else if (option.selected) {
					option.selected = false;
				}
			}
			// Reset to default if the active endpoint isn't valid
			if (activeEndpoint && !activeEndpointIsValid) {
				const defaultOption = dropdown.querySelector<HTMLOptionElement>("option.default");
				if (defaultOption) {
					// Clear the cookie by setting negative Max-Age
					setCookieEndpoint();
					window.location.reload();
				}
			}

			// 3) Set up endpoint change handler, which will set the cookie and reload the page
			dropdown.addEventListener('change', () => {
				setCookieEndpoint(dropdown.value);
				window.location.reload();
			});
		}
	});
})();
